import React from 'react';
import Icons from 'components/icons';
import styles from './input.module.scss';

const Input = ({
  type = 'text',
  onDecrement,
  onIncrement,
  onWheel,
  controlsUnder = false,
  label,
  error,
  onRemove,
  onReset,
  disabled,
  forwardRef,
  ...rest
}) => {
  const onWheelCustom = (event) => {
    if (type === 'number' && document.activeElement === event.currentTarget) {
      event.currentTarget.blur();
    }

    if (onWheel) {
      onWheel(event);
    }
  };

  return (
    <div className={styles.input}>
    {label ? (
      <div className={styles.label}>
        <label>{label}</label>
      </div>
    ) : null}
    <div className={styles.target}>
      <div className={`${styles.block} ${error ? styles.targetError : ''}`}>
        {!disabled && type === 'number' && !controlsUnder && (
          <>
            <button type="button" className={styles.decrement} onClick={onDecrement} />
            <button type="button" className={styles.increment} onClick={onIncrement} />
          </>
        )}
        {error ? (
          <a className={styles.errorIcon} onClick={onReset} onKeyDown={() => {}} title="Сбросить значение">
            <Icons name="cancel" />
          </a>
        ) : null}
        {forwardRef ? (
          <input ref={forwardRef} disabled={disabled} type={type} onWheel={onWheelCustom} {...rest} />
        ) : (
          <input disabled={disabled} type={type} onWheel={onWheelCustom} {...rest} />
        )}
        {!disabled && type === 'number' && controlsUnder && (
          <div className={styles.controlsUnder}>
            <button type="button" className={styles.decrement} onClick={onDecrement} />
            <button type="button" className={styles.increment} onClick={onIncrement} />
          </div>
        )}
      </div>
      {onRemove ? (
        <a className={styles.remove} onClick={onRemove} onKeyDown={() => {}} title="Удалить">
          <Icons className={styles.removeIcon} name="cancel" fill="#333333" />
        </a>
      ) : null}
    </div>
    {error ? (
      <div className={styles.error}>{error}</div>
    ) : null}
  </div>
  );
};

export default Input;
